import callApi from './apiActions'

// Time ranges for fetching data
const hourlyRange = 7 * 24
const dailyRange = 90
const weeklyRange = 52
const monthlyRange = 36

// measurements api path determination based on time ranges, admin/user etc.
const getPath = (appId, time, apartment, room, privateLink) => {
    // How long time range to fetch
    var range = hourlyRange
    if (time === 'DAILY') range = dailyRange
    if (time === 'WEEKLY') range = weeklyRange
    if (time === 'MONTHLY') range = monthlyRange

    // Admin / user have different auth methods
    // Admin uses tokens and users have private links
    var path = ''
    if (!privateLink) {
        path = `measurements/${time}/${appId}?range=${range}`
        if (apartment && !room) {
            path = `measurements/${time}/${appId}/${apartment}?range=${range}`
        }
        else if (apartment && room) {
            path = `measurements/${time}/${appId}/${apartment}/${room}?range=${range}`
        }
    }
    else {
        path = `user/${privateLink}/measurements/${time}/${appId}?range=${range}`
        if (apartment && !room) {
            path = `user/${privateLink}/measurements/${time}/${appId}/${apartment}?range=${range}`
        }
        else if (apartment && room) {
            path = `user/${privateLink}/measurements/${time}/${appId}/${apartment}/${room}?range=${range}`
        }
    }
    return path.toLowerCase()
}

// These call the backend for measurement data
// If privateLink is given, call the users route with it
// Otherwise calls the admin route  that uses tokens for auth

// Building info, currently only apartments and rooms 
export const reqBuildingInfo = (appId, privateLink) => {
    var path = `measurements/info/${appId}?range=${monthlyRange}`
    if (privateLink) path = `user/${privateLink}/measurements/info/${appId}?range=${monthlyRange}`

    return dispatch => {
        dispatch({ type: 'REQUEST_MEASUREMENTS_INFO' })
        return dispatch(callApi('get', path, null, privateLink))
            .then(data => {
                dispatch({
                    type: 'REQUEST_MEASUREMENTS_INFO_SUCCESS',
                    payload: data.payload,
                    appId: appId
                })
            })
            .catch(err => {
                dispatch({ type: 'REQUEST_MEASUREMENTS_INFO_FAIL' })
            })
    }
}

// Readings for whole building (of appId)
export const reqBuilding = (appId, time, privateLink) => {
    return dispatch => {
        dispatch({ type: 'REQUEST_MEASUREMENTS' })
        var path = getPath(appId, time, null, null, privateLink)
        return dispatch(callApi('get', path, null, privateLink))
            .then(data => {
                dispatch({
                    type: `REQUEST_MEASUREMENTS_SUCCESS_${time}_BUILDING`,
                    payload: data.payload,
                    appId: appId
                })
            })
            .catch(err => dispatch({ type: 'REQUEST_MEASUREMENTS_FAIL' }))
    }
}

// Readings for given apartment (of appId)
export const reqApartment = (appId, time, apartment, privateLink) => {
    return dispatch => {
        dispatch({ type: 'REQUEST_MEASUREMENTS' })
        var path = getPath(appId, time, apartment, null, privateLink)
        return dispatch(callApi('get', path, null, privateLink))
            .then(data => {
                dispatch({
                    type: `REQUEST_MEASUREMENTS_SUCCESS_${time}_APARTMENT`,
                    payload: data.payload,
                    appId: appId,
                    apartment: apartment
                })
            })
            .catch(err => dispatch({ type: 'REQUEST_MEASUREMENTS_FAIL' }))
    }
}

// Readings for given room in given apartment (of appId)
export const reqRoom = (appId, time, apartment, room, privateLink) => {
    return dispatch => {
        dispatch({ type: 'REQUEST_MEASUREMENTS' })
        var path = getPath(appId, time, apartment, room, privateLink)
        return dispatch(callApi('get', path, null, privateLink))
            .then(data => {
                dispatch({
                    type: `REQUEST_MEASUREMENTS_SUCCESS_${time}_ROOM`,
                    payload: data.payload,
                    appId: appId,
                    apartment: apartment,
                    room: room
                })
            })
            .catch(err => dispatch({ type: 'REQUEST_MEASUREMENTS_FAIL' }))
    }
}



// WEBPACK FOOTER //
// ./src/actions/measurementsActions.js